// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
let __webpack_exports__ = __webpack_require__(2478);
